import * as React from 'react';
const SvgInstagram = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.6 6h-3.2c-1.153 0-1.898.002-2.464.048-.544.044-.745.12-.844.17a2 2 0 0 0-.874.874c-.05.099-.126.3-.17.844C6.002 8.502 6 9.246 6 10.4v3.2c0 1.153.002 1.898.048 2.464.044.544.12.745.17.844a2 2 0 0 0 .874.874c.099.05.3.126.844.17.566.046 1.31.048 2.464.048h3.2c1.153 0 1.898-.002 2.464-.048.544-.044.745-.12.844-.17a2 2 0 0 0 .874-.874c.05-.099.126-.3.17-.844.046-.566.048-1.31.048-2.464v-3.2c0-1.153-.002-1.898-.048-2.464-.044-.544-.12-.745-.17-.844a2 2 0 0 0-.874-.874c-.099-.05-.3-.126-.844-.17C15.498 6.002 14.754 6 13.6 6m-9.164.184C4 7.04 4 8.16 4 10.4v3.2c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C7.04 20 8.16 20 10.4 20h3.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C20 16.96 20 15.84 20 13.6v-3.2c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C16.96 4 15.84 4 13.6 4h-3.2c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M17 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
  </svg>
);
export default SvgInstagram;
